import axios from 'axios';
import Auth from '../lib/auth';
import utilsLib from './utils.lib';
import { addNotification } from './notifications';
import {saveFile} from "../lib/content-lib";

export const GET_QUOTES_REQUEST = 'GET_QUOTES_REQUEST';
export const GET_QUOTES_SUCCESS = 'GET_QUOTES_SUCCESS';
export const GET_QUOTES_ERROR = 'GET_QUOTES_ERROR';

export const GET_QUOTE_REQUEST = 'GET_QUOTE_REQUEST';
export const GET_QUOTE_SUCCESS = 'GET_QUOTE_SUCCESS';
export const GET_QUOTE_ERROR = 'GET_QUOTE_ERROR';

export const CREATE_QUOTE_REQUEST = 'CREATE_QUOTE_REQUEST';
export const CREATE_QUOTE_SUCCESS = 'CREATE_QUOTE_SUCCESS';
export const CREATE_QUOTE_ERROR = 'CREATE_QUOTE_ERROR';

export const UPDATE_QUOTE_REQUEST = 'UPDATE_QUOTE_REQUEST';
export const UPDATE_QUOTE_SUCCESS = 'UPDATE_QUOTE_SUCCESS';
export const UPDATE_QUOTE_ERROR = 'UPDATE_QUOTE_ERROR';

export const CHANGE_STATUS_QUOTE_REQUEST = 'CHANGE_STATUS_QUOTE_REQUEST';
export const CHANGE_STATUS_QUOTE_SUCCESS = 'CHANGE_STATUS_QUOTE_SUCCESS';
export const CHANGE_STATUS_QUOTE_ERROR = 'CHANGE_STATUS_QUOTE_ERROR';

export const UPLOAD_QUOTE_FILES_REQUEST = 'UPLOAD_QUOTE_FILES_REQUEST';
export const UPLOAD_QUOTE_FILES_PROGRESS = 'UPLOAD_QUOTE_FILES_PROGRESS';
export const UPLOAD_QUOTE_FILES_SUCCESS = 'UPLOAD_QUOTE_FILES_SUCCESS';
export const UPLOAD_QUOTE_FILES_ERROR = 'UPLOAD_QUOTE_FILES_ERROR';

export const DELETE_QUOTE_FILE_REQUEST = 'DELETE_QUOTE_FILE_REQUEST';
export const DELETE_QUOTE_FILE_SUCCESS = 'DELETE_QUOTE_FILE_SUCCESS';
export const DELETE_QUOTE_FILE_ERROR = 'DELETE_QUOTE_FILE_ERROR';

export const DELETE_QUOTE_REQUEST = 'DELETE_QUOTE_REQUEST';
export const DELETE_QUOTE_SUCCESS = 'DELETE_QUOTE_SUCCESS';
export const DELETE_QUOTE_ERROR = 'DELETE_QUOTE_ERROR';

export const CLEAN_QUOTES = 'CLEAN_QUOTES';

// Get quotes
export function getQuotes(query) {
    return async (dispatch) => {
        try {
            dispatch(getQuotesRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.post('/api/quotes/query', query, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, getQuotesSuccess, getQuotesError));
        } catch (err) {
            dispatch(utilsLib.response(err, getQuotesError));
        }
    };
}
function getQuotesRequest() {
    return {
        type: GET_QUOTES_REQUEST,
        isFetching: true
    };
}
function getQuotesSuccess (payload) {
    return {
        type: GET_QUOTES_SUCCESS,
        isFetching: false,
        error: false,
        payload
    };
}
function getQuotesError(errorMessage) {
    return {
        type: GET_QUOTES_ERROR,
        isFetching: false,
        error: true,
        errorMessage
    };
}

// Get quote
export function getQuote(quoteId) {

    return async (dispatch) => {
        try {
            dispatch(getQuoteRequest());
            const token = Auth.getLocalJwt();
            const res = await axios.get(`/api/quotes/${quoteId}`, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, getQuoteSuccess, getQuoteError));
        } catch (err) {
            dispatch(utilsLib.response(err, getQuoteError));
        }
    };
}
function getQuoteRequest() {
    return {
        type: GET_QUOTE_REQUEST,
        isFetching: true
    };
}
function getQuoteSuccess (payload) {
    return {
        type: GET_QUOTE_SUCCESS,
        isFetching: false,
        error: false,
        payload
    };
}
function getQuoteError(errorMessage) {
    return {
        type: GET_QUOTE_ERROR,
        isFetching: false,
        error: true,
        errorMessage
    };
}

// Create quote
export function createQuote(quote, options) {
    return async (dispatch) => {
        try {
            dispatch(createQuoteRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.post('/api/quotes', {quote, options}, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, createQuoteSuccess, createQuoteError));
        } catch (err) {
            dispatch(utilsLib.response(err, createQuoteError));
        }
    };
}
function createQuoteRequest() {
    return {
        type: CREATE_QUOTE_REQUEST,
        isFetching: true
    };
}
function createQuoteSuccess (payload) {
    return dispatch => {
        // Create notification for create quote success
        dispatch(addNotification({
            message: 'Presupuesto añadido correctamente',
            color: 'green',
            icon: 'tick'
        }));

        dispatch({
            type: CREATE_QUOTE_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function createQuoteError(errorMessage) {
    return dispatch => {
        // Create notification for create quote error
        dispatch(addNotification({
            message: 'Error al añadir el presupuesto',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: CREATE_QUOTE_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Update quote
export function updateQuote(quoteId, quote = {}) {
    return async (dispatch) => {
        try {
            dispatch(updateQuoteRequest());
            const token = Auth.getLocalJwt();
            const res = await axios.put(`/api/quotes/${quoteId}`, quote, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, updateQuoteSuccess, updateQuoteError));
        } catch (err) {
            dispatch(utilsLib.response(err, updateQuoteError));
        }
    };
}
function updateQuoteRequest() {
    return {
        type: UPDATE_QUOTE_REQUEST,
        isFetching: true
    };
}
function updateQuoteSuccess (payload) {
    return dispatch => {
        // Create notification for update quote success
        dispatch(addNotification({
            message: 'Presupuesto actualizado correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: UPDATE_QUOTE_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function updateQuoteError(errorMessage) {
    return dispatch => {
        // Create notification for update quote error
        dispatch(addNotification({
            message: 'Error al actualizar el presupuesto',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: UPDATE_QUOTE_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Change quote status
export function changeQuoteStatus(quoteId, status, options = { populateRefs: true, calculateStatistics: 'quotes', deleteVirtuals: true }) {
    return async (dispatch) => {
        try {
            dispatch(changeQuoteStatusRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.put(`/api/quotes/${quoteId}/status`, { status, options }, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, changeQuoteStatusSuccess, changeQuoteStatusError));
        } catch (err) {
            dispatch(utilsLib.response(err, changeQuoteStatusError));
        }
    };
}
function changeQuoteStatusRequest() {
    return {
        type: CHANGE_STATUS_QUOTE_REQUEST,
        isFetching: true
    };
}
function changeQuoteStatusSuccess (payload) {
    return dispatch => {
        // Create notification for update status success
        dispatch(addNotification({
            message: 'Estado actualizado correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: CHANGE_STATUS_QUOTE_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function changeQuoteStatusError(errorMessage) {
    return dispatch => {
        // Create notification for update status error
        dispatch(addNotification({
            message: 'Error al actualizar el estado',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: CHANGE_STATUS_QUOTE_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Upload quote files
export function uploadQuoteFiles(quoteId, files) {
    return async (dispatch) => {
        try {
            dispatch(uploadQuoteFilesRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.post(`/api/quotes/${quoteId}/files`, files, {
                headers: { 'Authorization': 'Bearer ' + token },
                onUploadProgress: function (e) {
                    dispatch(uploadQuoteFilesProgress(e.loaded / e.total))
                }
            });

            dispatch(utilsLib.response(res, uploadQuoteFilesSuccess, uploadQuoteFilesError));
        } catch (err) {
            dispatch(utilsLib.response(err, uploadQuoteFilesError));
        }
    };
}
function uploadQuoteFilesRequest() {
    return {
        type: UPLOAD_QUOTE_FILES_REQUEST,
        isFetching: true
    };
}
function uploadQuoteFilesProgress(percent) {
    return {
        type: UPLOAD_QUOTE_FILES_PROGRESS,
        percent
    };
}
function uploadQuoteFilesSuccess (payload) {
    return dispatch => {
        // Create notification for upload quote file success
        dispatch(addNotification({
            message: 'Ficheros subidos correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: UPLOAD_QUOTE_FILES_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function uploadQuoteFilesError(errorMessage) {
    return dispatch => {
        // Create notification for upload quote file error
        dispatch(addNotification({
            message: 'Error al subir los ficheros',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: UPLOAD_QUOTE_FILES_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Download quote file
export function downloadQuoteFile(quoteId, fileId) {
    return async (dispatch) => {
        try {
            const token = Auth.getLocalJwt();
            const res = await axios.get(`/api/quotes/${quoteId}/files/${fileId}`, {
                headers: { 'Authorization': 'Bearer ' + token },
                responseType: 'blob'
            });

            if( res.status === 200 ) {
                saveFile(res);
            }

        } catch (err) {
            dispatch(addNotification({
                message: 'Error al descargar el fichero',
                color: 'red',
                icon: 'warning-sign'
            }));
        }
    };
}

// Delete quote file
export function deleteQuoteFile(quoteId, fileId) {
    return async (dispatch) => {
        try {
            dispatch(deleteQuoteFileRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.delete(`/api/quotes/${quoteId}/files/${fileId}`, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, deleteQuoteFileSuccess, deleteQuoteFileError));
        } catch (err) {
            dispatch(utilsLib.response(err, deleteQuoteFileError));
        }
    };
}
function deleteQuoteFileRequest() {
    return {
        type: DELETE_QUOTE_FILE_REQUEST,
        isFetching: true
    };
}
function deleteQuoteFileSuccess (payload) {
    return dispatch => {
        // Create notification for delete file success
        dispatch(addNotification({
            message: 'Fichero eliminado correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: DELETE_QUOTE_FILE_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function deleteQuoteFileError(errorMessage) {
    return dispatch => {
        // Create notification for delete file error
        dispatch(addNotification({
            message: 'Error al eliminar el fichero',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: DELETE_QUOTE_FILE_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Delete quote
export function deleteQuote(quoteId) {

    return async (dispatch) => {
        try {
            dispatch(deleteQuoteRequest());
            const token = Auth.getLocalJwt();
            const res = await axios.delete(`/api/quotes/${quoteId}`, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, deleteQuoteSuccess, deleteQuoteError));
        } catch (err) {
            dispatch(utilsLib.response(err, deleteQuoteError));
        }
    };
}
function deleteQuoteRequest() {
    return {
        type: DELETE_QUOTE_REQUEST,
        isFetching: true
    };
}
function deleteQuoteSuccess (payload) {
    return dispatch => {
        // Create notification for delete quote success
        dispatch(addNotification({
            message: 'Presupuesto eliminado correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: DELETE_QUOTE_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function deleteQuoteError(errorMessage) {
    return dispatch => {
        // Create notification for delete quote error
        dispatch(addNotification({
            message: 'Error al eliminar el presupuesto',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: DELETE_QUOTE_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Clean quotes reducer
export function cleanQuotes() {
    return {
        type: 'CLEAN_QUOTES',
        isFetching: false,
        error: false,
        payload: []
    }
}



// WEBPACK FOOTER //
// ./src/actions/quotes.js